import { getAuth } from "firebase/auth";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CreateSport from "../../../../Controllers/Admin/Sports/CreateSport";
import GetSingleSport from "../../../../Controllers/Admin/Sports/GetSingleSport";
import UpdateSport from "../../../../Controllers/Admin/Sports/UpdateSport";
import GetUser from "../../../../Controllers/Users/GetUser";
import { ToastSuccessMessages } from "../../../../Helpers/ToastMessages";

export default function AddSportViewModel() {
  const navigate = useNavigate();
  const location = useLocation();
  const [SchoolID, setSchoolID] = useState("");

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("schoolId"));
    setSchoolID(items);
  }, []);

  const [SportIDD, setSportIDD] = useState("");

  const [AuthUser, setAuthUser] = useState("");

  const [SportIDError, setSportIDError] = useState(false);
  const [SportNameError, setSportNameError] = useState(false);
  const [CoachNameError, setCoachNameError] = useState(false);
  const [StartedYearError, setStartedYearError] = useState(false);

  const [FormDisabled, setFormDisabled] = useState(false);
  const [IsUpdate, setIsUpdate] = useState(false);

  const [IsCheckError, setIsCheckError] = useState(false);
  const [AddSport, setAddSport] = useState({
    SportID: "",
    SportName: "",
    CoachName: "",
    StartedYear: "",
  });

  useEffect(() => {
    const LocationArray = location.pathname.split("/");
    setSportIDD(LocationArray.pop());

    if (LocationArray.includes("update")) {
      setIsUpdate(true);
      const fetchData = async () => {
        const SportData = await GetSingleSport(SportIDD);
        setAddSport({
          SportID: SportData?.SportID,
          SportName: SportData?.SportName,
          CoachName: SportData?.CoachName,
          StartedYear: SportData?.StartedYear,
        });
      };
      fetchData();
    } else {
    }
  }, [location.pathname, SportIDD]);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);
        setAuthUser(UserData);
      });
    }
    fetchData();
  }, []);

  const UIErrorHandling = useCallback(() => {
    let flag = 0;

    if (
      AddSport.SportID === "" ||
      AddSport.SportID === null ||
      AddSport.SportID === undefined
    ) {
      setSportIDError(true);
      flag++;
    } else {
      setSportIDError(false);
    }

    if (
      AddSport.SportName === "" ||
      AddSport.SportName === null ||
      AddSport.SportName === undefined ||
      AddSport.SportName.length < 3
    ) {
      setSportNameError(true);
      flag++;
    } else {
      setSportNameError(false);
    }

    if (
      AddSport.CoachName === "" ||
      AddSport.CoachName === null ||
      AddSport.CoachName === undefined ||
      AddSport.CoachName.length < 3
    ) {
      setCoachNameError(true);
      flag++;
    } else {
      setCoachNameError(false);
    }

    if (
      AddSport.StartedYear === "" ||
      AddSport.StartedYear === null ||
      AddSport.StartedYear === undefined ||
      AddSport.StartedYear.length < 4
    ) {
      setStartedYearError(true);
      flag++;
    } else {
      setStartedYearError(false);
    }

    return flag;
  }, [
    AddSport.SportID,
    AddSport.SportName,
    AddSport.CoachName,
    AddSport.StartedYear,
  ]);

  useEffect(() => {
    if (IsCheckError) UIErrorHandling();
  }, [IsCheckError, UIErrorHandling]);

  const RegisterSport = async () => {
    setIsCheckError(true);
    let flag = 0;
    flag = UIErrorHandling();

    if (flag === 0) {
      setFormDisabled(true);
      if (IsUpdate) {
        const SportFinalObject = {
          ...AddSport,
        };

        await UpdateSport(SportFinalObject, SportIDD)
          .then(() => {
            ToastSuccessMessages("sports/update-successful");
            navigate("/user/admin/sports");
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        const SportFinalObject = {
          ...AddSport,
        };

        await CreateSport(SportFinalObject, AuthUser?.uid, SchoolID)
          .then(() => {
            ToastSuccessMessages("sports/add-successful");
            navigate("/user/admin/sports");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      setFormDisabled(false);
    }
  };

  return {
    RegisterSport,
    AddSport,
    setAddSport,
    SportIDError,
    SportNameError,
    CoachNameError,
    StartedYearError,
    FormDisabled,
    IsUpdate,
  };
}
